/* eslint-disable react/prop-types */
/* eslint-disable no-new */
import React, { Component } from "react";
import Pikaday from "pikaday";
import moment from "moment";

import DATE_FORMATS from "../utilities/constants";

class DateField extends Component {
  componentDidMount() {
    const { onChange } = this.props;
    this.name = this.input.getAttribute("name");

    new Pikaday({
      field: this.input,
      format: DATE_FORMATS.DateHumanReadable,
      defaultDate: moment().toDate(),
      setDefaultDate: 1,
      minDate: moment().toDate(),
      maxDate: moment(
        moment()
          .add(60, "days")
          .format(DATE_FORMATS.Date)
      ).toDate(),
      onSelect: date => {
        const value = moment(date).format(DATE_FORMATS.Date);
        onChange({ [this.name]: value });
      }
    });
  }

  render() {
    const { name } = this.props;

    return (
      <input
        ref={e => {
          this.input = e;
        }}
        name={name}
        type="text"
        className="ember-view ember-text-field date-input"
      />
    );
  }
}

export default DateField;
